import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";

import { Navigation, Autoplay } from "swiper/modules";

// React Icons
import {
  FaBuilding,
  FaCouch,
  FaTools,
  FaBath,
  FaPaintRoller,
  FaDraftingCompass,
  FaHome
} from "react-icons/fa";

const Services = () => {
  return (
    <div className="container-fluid py-5">
      <div className="container py-5">
        <div className="row">

          {/* LEFT SIDE */}
          <div className="col-lg-6 pr-lg-5">
            <h6 className="text-primary text-uppercase mb-3">
              Our Services
            </h6>

            <h1 className="mb-4 section-title">
              CONSTRUCTION & INTERIOR SOLUTIONS
            </h1>

            <p>
              We provide complete constructions and interior service with quality, precision, and on-time delivery.
            </p>

            <a href="#" className="btn btn-primary mt-3 py-2 px-4">
              View More
            </a>
          </div>

          {/* RIGHT SIDE SLIDER */}
          <div className="col-lg-6 p-0 pt-5 pt-lg-0 position-relative">

            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={20}
              slidesPerView={2}
              navigation={{
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
              }}
              loop={true}
              speed={900}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
              }}
            >

              <SwiperSlide>
                <div className="service-card">
                  <FaBuilding className="icon" />
                  <h5>Residential & Commercial Construction</h5>
                  <p>Diam amet eos at no eos sit lorem.</p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="service-card">
                  <FaCouch className="icon" />
                  <h5>Interior Design Execution</h5>
                  <p>Diam amet eos at no eos sit lorem.</p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="service-card">
                  <FaTools className="icon" />
                  <h5>Civil Work Renovation</h5>
                  <p>Diam amet eos at no eos sit lorem.</p>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="service-card">
                  <FaBath className="icon" />
                  <h5>Bathroom Design</h5>
                  <p>Diam amet eos at no eos sit lorem.</p>
                </div>
              </SwiperSlide>

            </Swiper>

            {/* 🔥 CUSTOM NAV BUTTONS (LIKE YOUR IMAGE) */}
            <div className="swiper-prev custom-nav">
              <span>&#10094;</span>
            </div>

            <div className="swiper-next custom-nav">
              <span>&#10095;</span>
            </div>

          </div>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        .service-card {
          background: #f8f9fa;
          text-align: center;
          padding: 30px 20px;
          transition: all 0.4s ease;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
        }

        .service-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.12);
          background: #fff;
        }

        .icon {
          font-size: 55px;
          color: #DFB163;
          margin-bottom: 15px;
        }

        .service-card h5 {
          font-weight: 700;
          margin-bottom: 10px;
        }

        .service-card p {
          font-size: 14px;
          color: #666;
        }

        /* 🔥 NAV BUTTON STYLE (LIKE IMAGE) */
        .custom-nav {
          width: 45px;
          height: 45px;
          background: #666;
          border-radius: 50%;
          position: absolute;
          top: 40%;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 10;
          transition: 0.3s ease;
        }

        .custom-nav span {
          color: #DFB163;
          font-size: 20px;
          font-weight: bold;
        }

        .swiper-prev {
          left: 10px;
        }

        .swiper-next {
          right: 10px;
        }

        .custom-nav:hover {
          background: #444;
          transform: translateY(-50%) scale(1.1);
        }
      `}</style>
    </div>
  );
};

export default Services;